import React from "react";
import { connect } from "react-redux";
import Modal from "@components/Modal";
import ContentEditorComponent from "@components/ContentEditorView/ContentEditorComponent";
import { addModal } from "@store/app/actions";
import Button from "@components/Button";

const ModalBlock = ({ alignCenter, buttonTitle, id, children, addModal }) => (
  <>
    <div className={alignCenter ? "u-text-align-center" : ""}>
      <Button
        onClick={() => addModal(id)}
        title={buttonTitle}
        size="normal"
        variant="primary"
        classesProp="js-cms-modal"
      />
    </div>

    <Modal id={id} header={buttonTitle}>
      {children && <ContentEditorComponent content={children} />}
    </Modal>
  </>
);

export default connect(null, { addModal })(ModalBlock);
